export { default } from './RelatedNewsBlock';
export * from './RelatedNewsBlock';
